module.exports = __webpack_public_path__ + "static/media/dark-tire.0b216136.png";